import React from 'react';
import {
  signInClickHandler,
  showLoginLinkForNonLoggedInUsers,
} from '../DeliveryAddressSearchFormUtilities/DeliveryAddressSearchFormUtils';

const SignInSectionComp = props => {
  const { loggedIn = false, formContent = {}, storeSelection } = props;
  const { signInLink } = storeSelection;
  const { memberText = '', singInLink = {} } = formContent;
  return (
    <div className='login-section'>
      {signInLink && (
        <span className='delivery-member-signin'>
          {!loggedIn && showLoginLinkForNonLoggedInUsers(memberText, signInClickHandler, singInLink)}
        </span>
      )}
    </div>
  );
};

export const SignInSection = React.memo(SignInSectionComp);
